import { render, staticRenderFns } from "./LeavegeneralPage.vue?vue&type=template&id=487426a3"
import script from "./LeavegeneralPage.vue?vue&type=script&lang=js"
export * from "./LeavegeneralPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports